module.exports = __webpack_public_path__ + "static/ic-mia-54d48457d8ac508cbf588f398ce44dfe.png";